module.exports = __webpack_public_path__ + "img/v1_gift_box.fc60554b.svg";